import config from 'config';
import { kebabCase, omit } from 'lodash';
import { CLOUDINARY_PATH } from '$util/image/cloudinary';
import type { ProcessedCmsContentfulImage } from '$cms/contentful.types';
import type { Props as ImageProps } from '$components/basic/Image';

const env = config.get('public.environment');

export const getCarLogoImgSrc = (make: string) =>
  `${CLOUDINARY_PATH}/car-logos-${env}/${kebabCase(make)}.png`;

export const convertImageProps = (image: ProcessedCmsContentfulImage): ImageProps => ({
  ...omit(image.img, 'original_secure_url'),
  alt: image.alt,
  title: image.title,
  src: image.img.original_secure_url,
});
